import { apiBaseUrl } from './config';

/**
 * Low-level fetch helpers against the host marketplace's OWN API proxy (which
 * forwards to empavision with the service token + integration id injected
 * server-side). All helpers fail soft — a network/parse error returns `null`,
 * never throws — so an extension can render nothing instead of crashing the host.
 */

/**
 * GET JSON from a host-proxy path. Returns the parsed body, or `null` on any failure.
 * @param {string} path - e.g. '/api/empavision/search'
 * @param {{ params?: Record<string, string|number>, rootUrl?: string }} [opts]
 * @returns {Promise<any|null>}
 */
export const getJson = async (path, { params, rootUrl } = {}) => {
  try {
    const base = apiBaseUrl(rootUrl);
    const url = new URL(`${base}${path}`);
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          url.searchParams.set(key, String(value));
        }
      });
    }
    const response = await window.fetch(url.toString(), {
      method: 'GET',
      credentials: 'include',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) {
      return null;
    }
    return await response.json();
  } catch (error) {
    return null;
  }
};

/**
 * POST JSON to a host-proxy path. Returns the parsed body, or `null` on any failure.
 * @param {string} path
 * @param {object} body
 * @param {{ rootUrl?: string }} [opts]
 * @returns {Promise<any|null>}
 */
export const postJson = async (path, body, { rootUrl } = {}) => {
  try {
    const response = await window.fetch(`${apiBaseUrl(rootUrl)}${path}`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {}),
    });
    if (!response.ok) {
      return null;
    }
    return await response.json();
  } catch (error) {
    return null;
  }
};
